import React from 'react'

const Blog = () => {
  return (
    <div className="globalmainstyles">
      Blog
    </div>
  )
}

export default Blog
